import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { ShiftTotal } from 'shared/api';
import { shiftsPageModel } from '../../model';
import { ShiftsPageCard } from '../shifts-page-card';
import { ShiftPageContribution } from '../shifts-page-contribution';
import cls from './shifts-page-shift.module.scss';

export type ShiftsPageShiftProps = {
	shift: ShiftTotal | null;
};

export const ShiftsPageShift = ({ shift }: ShiftsPageShiftProps) => {
	const { t } = useTranslation();

	const isPersonal = useUnit(shiftsPageModel.isPersonal.$value);

	return (
		<div className={cls.shiftsPageShift}>
			<ShiftPageContribution />
			<div className={cls.shiftsPageShiftBody}>
				<ShiftsPageCard
					value={shift?.openingBalance ?? 0}
					title={t('shifts-page.opening-balance')}
				/>
				<ShiftsPageCard
					value={shift?.closingBalance ?? 0}
					title={t('shifts-page.closing-balance')}
				/>
				<ShiftsPageCard
					value={shift?.totalDeposits ?? 0}
					title={isPersonal ? t('shifts-page.my-deposits') : t('shifts-page.total-deposits')}
				/>
				<ShiftsPageCard
					value={shift?.totalWithdrawals ?? 0}
					title={isPersonal ? t('shifts-page.my-withdrawals') : t('shifts-page.total-withdrawals')}
				/>
				<ShiftsPageCard
					value={shift?.totalIncome ?? 0}
					title={isPersonal ? t('shifts-page.my-income') : t('shifts-page.total-income')}
				/>
				<ShiftsPageCard
					value={shift?.owner.name ?? ''}
					title={t('shifts-page.owner')}
					withCurrency={false}
				/>
			</div>
		</div>
	);
};
